(function () {
  function initAboutSection(section) {
    if (!section || section.dataset.aboutInitialized === 'true') {
      return;
    }

    const openButton = section.querySelector('[data-story-open]');
    const closeButton = section.querySelector('[data-story-close]');
    const storyPanel = section.querySelector('[data-story-panel]');

    if (!openButton || !storyPanel) {
      return;
    }

    section.dataset.aboutInitialized = 'true';

    function openStory() {
      storyPanel.classList.add('is-open');
      storyPanel.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');

      window.setTimeout(function () {
        storyPanel.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 120);
    }

    function closeStory(scrollBack) {
      storyPanel.classList.remove('is-open');
      storyPanel.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');

      if (scrollBack) {
        window.setTimeout(function () {
          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 50);
      }
    }

    function toggleStory() {
      const isOpen = storyPanel.classList.contains('is-open');

      if (isOpen) {
        closeStory(false);
      } else {
        openStory();
      }
    }

    openButton.addEventListener('click', toggleStory);

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeStory(true);
      });
    }

    openButton.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleStory();
      }
    });
  }

  function initAllAboutSections(root) {
    const scope = root || document;

    if (
      scope.matches &&
      scope.matches('[data-about-section]')
    ) {
      initAboutSection(scope);
    }

    const sections = scope.querySelectorAll
      ? scope.querySelectorAll('[data-about-section]')
      : [];

    sections.forEach(function (section) {
      initAboutSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllAboutSections(document);
    });
  } else {
    initAllAboutSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const sectionElement = event.target;

    if (!sectionElement) {
      return;
    }

    sectionElement
      .querySelectorAll('[data-about-section]')
      .forEach(function (section) {
        section.dataset.aboutInitialized = 'false';
        initAboutSection(section);
      });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const sectionElement = event.target;

    if (!sectionElement) {
      return;
    }

    sectionElement
      .querySelectorAll('[data-about-section]')
      .forEach(function (section) {
        section.dataset.aboutInitialized = 'false';
      });
  });
})();